import { useMutation, useQueryClient, UseMutationResult } from 'react-query'
import {
  createPoliDirectDebit,
  verifyPoliTransaction,
  createBlinkpayDirectDebit,
  verifyBlinkpayTransaction,
  verifyStripeTransaction
} from 'api/transfers'

export function useMutatePoliDirectDebit(): UseMutationResult<
  { navigationUrl: string },
  unknown,
  { amount: number; productId: number }
> {
  return useMutation(createPoliDirectDebit)
}

export function useMutateVerifyPoliTransaction(): UseMutationResult<
  { success: boolean; message: string; transactionStatus: string },
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifyPoliTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}

// Derived from the api/transfers signatures rather than restated. Hand-copied
// shapes silently drift: adding review_order_id / purchaseExecuted there left these
// stale, and because the mismatch is only reachable through the hook it slipped past
// `yarn build` and the unit suite — the Storybook type-check was what caught it.
export function useMutateBlinkpayDirectDebit(): UseMutationResult<
  Awaited<ReturnType<typeof createBlinkpayDirectDebit>>,
  unknown,
  Parameters<typeof createBlinkpayDirectDebit>[0]
> {
  return useMutation(createBlinkpayDirectDebit)
}

export function useMutateVerifyBlinkpayTransaction(): UseMutationResult<
  Awaited<ReturnType<typeof verifyBlinkpayTransaction>>,
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifyBlinkpayTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}

export function useMutateVerifyStripeTransaction(): UseMutationResult<
  { success: boolean; transactionStatus: string },
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifyStripeTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}
